import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import { SCREENS } from '~/constants/screens';
import { localeStore } from '~/mobx/localesStore';
import Text, { TEXT } from '~/view/components/Text/Text';
import branchEditStore from '~/view/screens/BranchesManagementScreen/screens/BranchEditScreen/store/branchEditStore';

const BranchProfileLink = observer(() => (
  <>
    <Text type={TEXT.SECTION_HEADER} text="branch_working_hours_tab" className="my-4" />
    <Link
      to={{ pathname: SCREENS.BRANCHES_WORKING_HOURS(), state: { id: branchEditStore.editableBranch.branch_profile_id } }}
      className="color-mainblue text-size-18 family-regular"
    >
      {localeStore.t('go_to_wkh')}
    </Link>
  </>
));

export default BranchProfileLink;
